import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { FC } from 'react';

/** Mirrors the filter panel's option rows: box, label, count. */
export const ReviewFilterPanelSkeleton: FC = () => (
  <Box sx={{ px: 1.25 }}>
    {Array.from({ length: 4 }).map((_, index) => (
      // oxlint-disable-next-line react/no-array-index-key
      <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1.25, height: 44, mb: '1px' }}>
        <Skeleton variant="rectangular" width={18} height={18} sx={{ borderRadius: '5px' }} />
        <Skeleton variant="text" sx={{ flex: 1 }} />
        <Skeleton variant="text" width={24} />
      </Box>
    ))}
  </Box>
);
